function beforeEnter (to, from, next) {
  document.getElementsByClassName('preload-loader__container')[0].style.display = 'none'
  next()
}

const Home = {
  path: '/view/:token/:section?',
  name: 'home',
  component: () => import(/* webpackChunkName: "Expired" */ '../../../views/Gateway.vue'),
}

const Expired = {
  path: '/expired',
  name: 'expired',
  beforeEnter,
  component: () => import(/* webpackChunkName: "Expired" */ '../../../views/ReportV4/Expired.vue'),
}

const NotFound = {
  path: '*',
  name: 'notFound',
  beforeEnter,
  component: () => import(/* webpackChunkName: "NotFound" */ '../../../views/ReportV4/NotFound.vue'),
}

export {
  Home,
  Expired,
  NotFound,
}
